import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGame } from '../context/GameContext';
import ScoreBoard from '../components/common/ScoreBoard';

export default function PlayerScore() {
  const { scores, groupName, gameStatus } = useGame();
  const navigate = useNavigate();
  const prevStatusRef = useRef(gameStatus);

  useEffect(() => {
    const prev = prevStatusRef.current;
    prevStatusRef.current = gameStatus;
    if (gameStatus === 'in_progress') navigate('/game');
    // When admin opens registrations, go back to lobby
    if (prev === 'ended' && gameStatus === 'waiting') navigate('/game');
  }, [gameStatus, navigate]);

  const myScore = scores.find((s) => s.groupName === groupName);

  const podiumIcon = (rank: number) => {
    if (rank === 1) return '🏆';
    if (rank === 2) return '🥈';
    if (rank === 3) return '🥉';
    return '🎵';
  };

  return (
    <div className="player-page">
      <div className="player-card">
        {myScore && (
          <div className="my-result">
            <div className="result-icon">{podiumIcon(myScore.rank)}</div>
            <h2>{groupName}</h2>
            <div className="result-points">{myScore.totalPoints} points</div>
            <div className="result-rank">#{myScore.rank}</div>
          </div>
        )}
        <h3>{gameStatus === 'ended' ? '🏆 Classement final' : 'Classement provisoire'}</h3>
        <ScoreBoard scores={scores} />
        {gameStatus === 'ended' && (
          <button
            className="btn btn-primary btn-full"
            style={{ marginTop: '1.5rem' }}
            onClick={() => { localStorage.removeItem('groupName'); navigate('/'); }}
          >
            Retour à l'accueil
          </button>
        )}
      </div>
    </div>
  );
}
